/* eslint-disable no-console */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Logo from '../includes/Logo';
import '../../themes/quill-nile.css';
import getI18nService from '../../i18n/i18n';
import { Context } from '../../store/Store';
import { CustomTypography } from '../../common/CustomTypoGraphy';

import { Button } from '@mui/material';
import Footer from '../includes/Footer';

const i18n = getI18nService();

const LoginSuccess = () => {
  const theme = useTheme();

  const navigate = useNavigate();
  const [state, dispatch] = useContext(Context);
  const { ui } = state;
  const { customization } = ui || {};

  return (
    <>
      {customization && (
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            boxShadow: 'rgb(0 0 0 / 25%) 2px 4px 10px 4px',
            backgroundColor: theme.palette.common.black || '#000000',
            opacity: 0.7,
            position: 'fixed',
            top: '45%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Box
            id="sms-login-box"
            display="flex"
            flexDirection="column"
            alignContent="center"
            alignItems={{ xs: 'center', sm: 'center' }}
            justifyContent="center"
            sx={{
              px: { xs: 2, sm: 4 },
              py: 2,
              height: 'auto', //{ xs: 515, sm: 465 },
              width: { xs: 400, sm: 652 },
            }}
          >
            <Box textAlign="center">
              {customization?.logo?.data && <Logo data={customization.logo.data} css={customization.logo.css} />}
            </Box>
            <CustomTypography
              sx={{
                fontSize: {
                  xs: '24px',
                  sm: '36px',
                },
                textAlign: 'center',
                padding: '12px 0px 4px 0px',
                color: 'healthy.main',
              }}
            >
              {i18n.t('Messages.youAreNowOnline')}
            </CustomTypography>
            {/* <CustomTypography
              sx={{
                fontSize: {
                  xs: '16px',
                  sm: '24px',
                },
                fontWeight: 500,
                color: 'text.white',
                textAlign: 'center',
              }}
            
              {i18n.t('Messages.authenticationSuccessful')}
            </CustomTypography> */}
          </Box>
          <Footer />
        </Paper>
      )}
    </>
  );
};

LoginSuccess.propTypes = {
  // title: PropTypes.string.isRequired,
};

export default LoginSuccess;
